import { useEffect } from 'react';
import useLoaderModal from 'components/modal/loaderModal/useLoaderModal';
import useAppQuery from '../useAppQuery';
import API from '../../services/API';

const useGetGuidebookAccessUrl = () => {
  const { openLoaderModal, closeLoaderModal } = useLoaderModal();

  const { refetch: getGuidebookAccessUrl, isFetching } = useAppQuery({
    queryKey: ['guidebookAccessUrl'],
    queryFn: async () => {
      const response = await API.get<{ url: string }>(
        '/api/identity/internal/guidebooks/access-url',
      );
      return response.data;
    },
    enabled: false,
  });

  useEffect(() => {
    if (isFetching) {
      openLoaderModal();
    } else {
      closeLoaderModal();
    }
  }, [isFetching]);

  return { getGuidebookAccessUrl, isFetching };
};

export default useGetGuidebookAccessUrl;
